import React from 'react';

import { useTranslation } from 'react-i18next';

import { ContentNotificationDeliveryTypeEnum } from 'constants-notifications';

import type { NotificationDeliveryTypeSummary } from '../helpers/getNotificationDeliveryTypeSummary';

import Pill from 'components/general/Pill';
import Tooltip from 'components/general/Tooltip';

const NO_NOTIFICATIONS_PLACEHOLDER = '--';

const TRANSLATION_KEYS = {
  assignedCount:
    'web.admin.channel.contentCenter.table.notificationType.assigned',
};

const DELIVERY_TYPE_TRANSLATION_KEYS: Record<
  ContentNotificationDeliveryTypeEnum,
  string
> = {
  [ContentNotificationDeliveryTypeEnum.Email]:
    'web.admin.channel.contentCenter.table.notificationType.email',
  [ContentNotificationDeliveryTypeEnum.Push]:
    'web.admin.channel.contentCenter.table.notificationType.push',
  [ContentNotificationDeliveryTypeEnum.SMS]:
    'web.admin.channel.contentCenter.table.notificationType.sms',
};

type NotificationTypeCellProps = {
  summary: NotificationDeliveryTypeSummary | null;
};

export function NotificationTypeCell({ summary }: NotificationTypeCellProps) {
  const { t } = useTranslation();

  if (!summary) {
    return NO_NOTIFICATIONS_PLACEHOLDER;
  }

  if (summary.kind === 'single') {
    return (
      <Pill
        text={t(DELIVERY_TYPE_TRANSLATION_KEYS[summary.deliveryType])}
        color="gray"
      />
    );
  }

  return (
    <Tooltip
      TooltipComponent={summary.deliveryTypes.map(deliveryType => (
        <div key={deliveryType}>
          {t(DELIVERY_TYPE_TRANSLATION_KEYS[deliveryType])}
        </div>
      ))}
    >
      <Pill
        text={t(TRANSLATION_KEYS.assignedCount, { count: summary.count })}
        color="gray"
      />
    </Tooltip>
  );
}
